import React, { FunctionComponent, ReactNode, useEffect, useRef, useState } from 'react'
import styles from './Ellipsis.module.sass'
import clsx from 'clsx'
import Tooltip from 'react-tooltip-lite'
import useMeasureDirty from 'react-use/esm/useMeasureDirty'

interface Props {
    className?: string,
    children: ReactNode,
    inline?: boolean,
    projectIcon?: boolean
}


const Ellipsis: FunctionComponent<Props> = props => {
    const ref = useRef<HTMLDivElement>(null)
    const [overflow, setOverflow] = useState(false)
    const {width} = useMeasureDirty(ref)

    useEffect(() => {
        if (ref.current) {
            setOverflow(ref.current.scrollWidth > ref.current.clientWidth)
        }
    }, [props.children, width])

    return <Tooltip
        className={clsx(props.className, styles.ellipsis, { [styles.inline]: props.inline })}
        useHover={overflow}
        content={props.children || ''}
    >
        <div
            ref={ref}
            className={clsx(styles.tooltip, props.projectIcon === true ? styles.projectIcon : '')}
        >
            {props.children}
        </div>
    </Tooltip>
}

export default Ellipsis